var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:[!_vm.showDetails ? 'parent-2' : 'showOnlyDetail']},[_c('v-card',{on:{"click":_vm.showContacts}},[_c('v-card-title',{staticClass:"info-title"},[_c('div',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.category.N_Chart)+" ")])])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }